import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import DHButtonIcon from "./DHButtonIcon";

export default function DHButtonIconDelete({ disabled, onClick}) {

    return <DHButtonIcon icon={<DeleteIcon/>} disabled={disabled} onClick={onClick}/>
}